// Avisos rápidos no rodapé da tela (sucesso / erro). Some sozinho; clicar fecha.

type Tipo = "ok" | "erro";

let area: HTMLElement | null = null;

function garanteArea(): HTMLElement {
  if (area && area.isConnected) return area;
  area = document.createElement("div");
  area.className = "toast-area";
  document.body.append(area);
  return area;
}

export function toast(texto: string, tipo: Tipo = "ok"): void {
  const el = document.createElement("div");
  el.className = `toast toast-${tipo}`;
  el.setAttribute("role", tipo === "erro" ? "alert" : "status");
  el.textContent = texto;

  const sair = (): void => {
    el.classList.add("toast-saindo");
    setTimeout(() => el.remove(), 320);
  };
  el.addEventListener("click", sair);
  setTimeout(sair, tipo === "erro" ? 6000 : 3500);

  garanteArea().append(el);
}

export const toastOk = (texto: string): void => toast(texto, "ok");
export const toastErro = (texto: string): void => toast(texto, "erro");
